import { Injectable } from '@angular/core';
import { GridLayoutService } from '@irb-common/interfaces/grid-layout.service';
import { ImportBlendedModelsErrorDialogComponent } from '@irb/irb-models/import-blended-model-error-dialog/import-blended-model-error-dialog.component';

@Injectable({
    providedIn: 'root'
})
export class ImportBlendedModelsErrorGridLayoutService implements GridLayoutService<ImportBlendedModelsErrorDialogComponent> {
    constructor() {}

    getFrameworkComponents() {
        return {};
    }

    getColumnDefs() {
        return [{
            headerName: 'Entity ',            
            field: 'entity',
            cellRenderer: 'cellRendererFormatter',
            cellRendererParams: {
              text: (params: any) => {
                  return (params.value != null && params.value.length > 0);
              }
          },
            minWidth: 220,
            flex: 1
        },
        {
            headerName: 'Error Condition',
            field: 'errorDesc',
            cellRenderer: 'cellRendererFormatter',
            cellRendererParams: {
              text: (params: any) => {
                  return (params.value != null && params.value.length > 0);
              }
          },
            minWidth: 250,
            flex: 3
        },
        {
            headerName: 'Line Number',
            field: 'lineNumber',
            minWidth: 10,
            flex: 1            
        }];
    }
}
